import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Icons, Images } from "../../assets/assets";
import OutlinedButton from "../../components/Button/OutlinedButton";
import { BiChevronRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";


import RefillFAQ from "../../components/RefillFAQ/RefillFAQ";
import Retailers from "../../components/Modal/Retailers/Retailers";
import faqServiceInstance from "../../APIs/faq";

interface FAQ {
  question: string;
  answer: string;

}


const GasCylinders = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCategoryId, ] = useState<any>(1);
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const showModal = () => {
    setIsModalVisible(true);
  };


  const [openSections, setOpenSections] = useState<{ [key: number]: boolean }>(
    {}
  );

  const toggleSection = (index: number) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [index]: !Boolean(prevState[index]),
    }));
  };

  useEffect(() => {
    const id = parseInt(selectedCategoryId, 10);

    if (!isNaN(id)) {
      fetchFaqByCategory(id);
    } else {
      console.error("Invalid category ID:", selectedCategoryId);
    }
  }, [selectedCategoryId]);


  const fetchFaqByCategory = async (category_id: number) => {
    try {
      const { data, error } = await faqServiceInstance.getFaqsByCategory(
        category_id
      );

      if (data) {
        setFaqs(data);
       

      } else {
        console.error("Error fetching FAQs:", error);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  


  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"CO2 Gas Cylinders | SodaStream SA"}</title>
        <meta
          name="description"
          content={
            "Never run out of gas on your sparkling water machines. Explore SodaStream CO2 gas cylinders, how they work, and where to buy them."
          }
        />
        <link
          rel="canonical"
          href={"https://www.sodastream.co.za/co2-gas-cylinders"}
        />
      </Helmet>
      <Header
        desktopHeight="70vh"
        title="The World of CO₂ Gas Cylinders"
        textBackground="GAS CYLINDERS"
        backgroundImg={Images.Page6BG}
        subTitle="Fast and reliable gas options to keep your sparkling water maker fizzing!"
      />

      <section className='className="relative z-10 mb-0 w-full"'>
        <div className="flex md:flex-row flex-col gap-0 w-full">
          <div className="basis-[50%] px-10 py-5 text-[#005D6E] bg-[#75A7AD80] text-start flex flex-col gap-5">
            <h2 className="text-[24px] font-bold">Exchange your cylinder</h2>
            <span className="text-[10px]">
              Exchange your empty cylinders for a full one and pay only for the
              refill.
            </span>
            <div className="flex gap-1 items-center justify-start">
              <Link to={"/exchange-refill"}>
                <p className="text-[20px]">How does it work?</p>
              </Link>

              <span className="mt-[-17px]">
                <BiChevronRight fontSize={25} />
              </span>
            </div>

            <div className="flex md:flex-row flex-col gap-4">
              <Retailers
                showModal={showModal}
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                buttonClassName="w-full px-4 py-2 h-[35px] bg-white rounded-[46px] opacity-100 flex items-center 
                justify-center cursor-pointer
    sm:w-fit sm:px-6 sm:py-2 sm:h-[40px]
    md:px-8 md:py-2 md:h-[35px]"
                buttonTitleClassName="text-[14px] leading-[24px] font font-bold text-[#75A7AD] 
                      sm:text-[16px] sm:leading-[19px]"
              />

              <a href="/gas-refills">
                <OutlinedButton
                  label="Learn More"
                  outLineButtonclassName="bg-transparent w-full
                 h-[35px] rounded-[46px] opacity-100 flex items-center justify-center 
                cursor-pointer px-4 border border-white sm:h-[40px]  md:h-[35px]  "
                />
              </a>
            </div>
          </div>
          <div className="basis-[50%] bg-[#75A7AD] text-white px-10 py-5 text-start flex flex-col gap-5">
            <h2 className="text-[#005D6E] font-bold text-[24px]">
              Get a spare
            </h2>
            <span className="text-white text-[10px]">
              Always have a spare on hand to keep your water sparkling
            </span>
            <div className="flex gap-1 items-center justify-start">
              <div className="flex gap-1 items-center justify-start">
                <Link to={"/gas-refills"}>
                  <p className="text-[20px]">
                    {" "}
                    <p className="text-[20px]">Why I should get a spare?</p>
                  </p>
                </Link>

                <span className="mt-[-17px]">
                  <BiChevronRight fontSize={25} />
                </span>
              </div>
            </div>
            <div className="flex md:flex-row flex-col gap-4">
              <Link to={"/spare"}>
                {/* <PrimaryButton
                  label="BUY ONLINE"
                  className="w-full px-4 py-2 h-[35px] bg-white rounded-[46px] opacity-100 flex items-center 
                justify-center cursor-pointer sm:w-fit sm:px-6 sm:py-2 sm:h-[40px] md:px-8 md:py-2 md:h-[35px] "
                /> */}
              </Link>

              <a href="/gas-refills">
                <OutlinedButton
                  label="Learn More"
                  outLineButtonclassName="bg-transparent w-full
                 h-[35px] rounded-[46px] opacity-100 flex items-center justify-center 
                cursor-pointer px-4 border border-white sm:h-[40px]  md:h-[35px]  "
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="text-[#005D6E] flex flex-col gap-10 grid-cols-2 items-center justify-center py-5 md:px-20 md:py-10 ">
          <h2 className="text-[20px]">SodaStream benefits</h2>
          <div className="md:flex md:flex-nowrap flex-wrap gap-5 grid grid-cols-2 md:gap-0 justify-between items-center">
            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                className="md:w-[40%] w-[20%]"
                src={Icons.IconSparklingSmall}
                alt="sparkling water"
              />
              <span className="md:font-bold text-[14px]">
                SUSTAINABLE SPARKLE
              </span>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                className="md:w-[40%] w-[20%]"
                src={Icons.IconQuickyEasy}
                alt="sparkling water"
              />
              <span className="md:font-bold text-[14px]">QUICK & EASY</span>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                className="md:w-[40%] w-[20%]"
                src={Icons.IconQualityFirst}
                alt="sparkling water"
              />
              <span className="md:font-bold text-[14px]">QUALITY FIRST</span>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                className="md:w-[40%] w-[20%]"
                src={Icons.IconFreshCertified}
                alt="sparkling water"
              />
              <span className="md:font-bold text-[14px]">
                FRESH & CERTIFIED
              </span>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="bg-[#efebe4] ">
          <div>
            <h1
              className="box-border text-center text-[rgb(0,93,110)]
             block text-[20px] pt-[20px] font-bold leading-[38.4px] ">
              Your Gas Guide
            </h1>
            <p
              className="box-border  mt-[-10px] text-center text-[rgb(0,93,110)] block 
    text-[18.6px] font-normal leading-[30.72px] p-4">
              Find the answers to all your cylinder and CO questions right here
            </p>
          </div>
        </div>
      </section>

      <section className="">
        <RefillFAQ
          faqs={faqs}
          toggleSection={toggleSection}
          openSections={openSections}
        />
      </section>

      <Footer />
    </div>
  );
};

export default GasCylinders;
